import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Volume } from 'user/models/get-it';

@Component({
  selector: 'app-pickup-volume-select',
  templateUrl: './pickup-volume-select.component.html',
  styleUrls: ['./pickup-volume-select.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => PickupVolumeSelectComponent),
    multi: true
  }]
})
export class PickupVolumeSelectComponent implements ControlValueAccessor {
  @Input() public volumes: Volume[];
  @Input() public selectedVolumeCode: string;
  @Input() public dataAutomationId: string;
  @Output() codeChanging = new EventEmitter<string>();
  public disabled: boolean;

  private onChange: (value: string) => void;
  private onTouched: () => void;

  writeValue(value: string): void {
    this.selectedVolumeCode = value;
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onVolumeChange(volumeCode: string) {
    this.writeValue(volumeCode);
    this.onChange(volumeCode);
    this.onTouched();
    this.codeChanging.emit(volumeCode);
  }
}
